import Vue from 'vue'
import 'babel-polyfill'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import request from '@/utils/request'
import request1 from '@/utils/request1'
import download from '@/utils/download'

import { getCookieDecrypt } from '@/utils/util'
import { common } from '@/utils/util'
import '@/utils/filters'
import Cookies from 'js-cookie'
import '@/icons' // svg icon

import '@/utils/flexible'
Vue.use(ElementUI)
Vue.prototype.$http = request
Vue.prototype.$http1 = request1
Vue.prototype.$download = download

Vue.prototype.$common = common

import VueLazyload from 'vue-lazyload'
// or with options
const loadimage = require('@assets/images/lazyLoading.gif')
const errorimage = require('@assets/images/error.png')
Vue.use(VueLazyload, {
  // preLoad: 1.3, //提前加载高度（数字 1 表示 1 屏的高度）
  error: errorimage,
  loading: loadimage,
  // attempt: 3  // 加载错误后最大尝试次数
})

// 适合移动端
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview, {
  fullscreenEl: false,
  zoomEl: false
})


import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer)

// 数字动效
import VueAnimateNumber from 'vue-animate-number'
Vue.use(VueAnimateNumber)

//全局组件
import GL_Component from '@utils/globalComponents'
Vue.use(GL_Component)

Vue.config.productionTip = false

// 全局修改message属性
Vue.prototype.$message = (msg) => {
  ElementUI.Message({ ...msg, duration: 9000, offset: 80 })
}
Vue.prototype.$message.success = (msg) => {
  return ElementUI.Message.success({ message: msg, offset: 80 })
}
Vue.prototype.$message.info = (msg) => {
  return ElementUI.Message.info({ message: msg, offset: 80 })
}
Vue.prototype.$message.warning = (msg) => {
  return ElementUI.Message.warning({ message: msg, offset: 80 })
}
Vue.prototype.$message.error = (msg) => {
  return ElementUI.Message.error({ message: msg, offset: 80 })
}


router.beforeEach((to, from, next) => {
  console.log('userid', getCookieDecrypt('userid'))

  if (getCookieDecrypt('userid')) {
    console.log('已登录')

    store.commit('SET_USER_INFO', {
      token: Cookies.get('token'),

      //解密数据 将数据先base64还原，再转为utf8数据
      userid: getCookieDecrypt('userid'),

      userName: getCookieDecrypt('userName'),

      headImg: Cookies.get('headImg'),

      phone: getCookieDecrypt('phone')
    })

    // next()
  }
  store.commit('SET_LOGIN_VERTIFY', Cookies.get('showVerify') === '1' ? true : false)
  next()
  // else if (to.path !== '/login' && to.path !== '/register') {
  //   // 未登录拦截
  //   next({ path: '/login' })
  // } else {
  //   next()
  // }
})

// router.afterEach((to, from, next) => {
//   // window.scrollTo(0, 0)

//   document.getElementById('app').scrollTop = 0
// })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
